import { instanceToInstance, instanceToPlain, plainToInstance, Transform } from "class-transformer";
import { validateSync } from "class-validator";
import { Err, ErrorCode } from "./error";
export function serialize(cl) {
    return instanceToPlain(cl);
}
export { Exclude, Type } from "class-transformer";
function toValidationErrorMessage(errors) {
    const messages = [];
    for (const err of errors) {
        if (err.constraints) {
            messages.push(Object.values(err.constraints).join(", "));
        }
        else if (err.property && err.children && err.children.length) {
            messages.push(`${err.property}: [${toValidationErrorMessage(err.children)}]`);
        }
    }
    return messages.join(", ");
}
export function deserialize(cl, obj, validate = false) {
    if (Array.isArray(obj)) {
        throw new Err(ErrorCode.ENCODING_ERROR, "Deserializing arrays not supported");
    }
    const inst = plainToInstance(cl, obj);
    if (validate && typeof inst === "object") {
        const errors = validateSync(inst);
        if (errors.length && errors.some((e) => e.property !== undefined || (e.children && e.children.length > 0))) {
            throw new Err(ErrorCode.VALIDATION_ERROR, `Ungültige Eingabe. ${toValidationErrorMessage(errors)}`);
        }
    }
    return inst;
}
export function deserializeArray(cl, obj, validate = false) {
    if (!Array.isArray(obj)) {
        throw new Err(ErrorCode.ENCODING_ERROR, "Object must be an array!");
    }
    const inst = plainToInstance(cl, obj);
    if (validate) {
        // validateSync on the array itself is a no-op (class-validator has no metadata for Array),
        // so each element has to be validated individually
        const messages = [];
        for (const [index, el] of inst.entries()) {
            if (typeof el !== "object" || el === null) {
                continue;
            }
            const errors = validateSync(el);
            if (errors.length &&
                errors.some((e) => e.property !== undefined || (e.children && e.children.length > 0))) {
                messages.push(`[${index}]: ${toValidationErrorMessage(errors)}`);
            }
        }
        if (messages.length) {
            throw new Err(ErrorCode.VALIDATION_ERROR, `Ungültige Eingabe. ${messages.join(", ")}`);
        }
    }
    return inst;
}
export function clone(cl) {
    return instanceToInstance(cl);
}
export const validate = validateSync;
export function bytesToHex(bytes) {
    return [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
}
export function hexToBytes(str) {
    const bytes = new Uint8Array(str.length / 2);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = parseInt(str.substring(i * 2, i * 2 + 2), 16);
    }
    return bytes;
}
export function intToBytes(x) {
    const y = Math.floor(x / 2 ** 32);
    return new Uint8Array([y, y << 8, y << 16, y << 24, x, x << 8, x << 16, x << 24].map((z) => z >>> 24));
}
const base32Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
export function bytesToBase32(arr) {
    let bits = 0;
    let value = 0;
    let str = "";
    for (let i = 0; i < arr.length; i++) {
        value = (value << 8) | arr[i];
        bits += 8;
        while (bits >= 5) {
            str += base32Chars[(value >>> (bits - 5)) & 31];
            bits -= 5;
        }
    }
    if (bits > 0) {
        str += base32Chars[(value << (5 - bits)) & 31];
    }
    return str;
}
export function TransformDateProperties(keys) {
    return Transform(({ value }) => {
        if (!value || typeof value !== "object") {
            return value;
        }
        for (const key of keys) {
            if (value[key]) {
                value[key] = new Date(value[key]);
            }
        }
        return value;
    }, { toClassOnly: true });
}
//# sourceMappingURL=encoding.js.map